import React from 'react'
import { DOOLAR_CIRCLE } from '../../../../shared/AppImages'

function NoAdditionalCharges() {
    return (
        <div className='no-additional-charge'>
            <div className='circle-div'>
                <img
                    src={DOOLAR_CIRCLE}
                    alt="Charges need to be calculated"
                />
            </div>
            <h2>Charges Need to be Calculated!</h2>
            <p>Please update date and time & calculate the
                price to get charges.</p>
        </div>
    )
}

export default NoAdditionalCharges